import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';

import { ItemMenu } from '@/app/common/interfaces/sidenav.types';
import { Router, RouterModule } from '@angular/router';
import { BehaviorSubject, Subscription, combineLatest, take } from 'rxjs';
import { SidenavService } from '../../../common/services/sidenav/sidenav.service';
import { NzMenuModule } from 'ng-zorro-antd/menu';
import {
  AsyncPipe,
  NgComponentOutlet,
  NgForOf,
  NgIf,
  NgTemplateOutlet,
} from '@angular/common';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { AuthService } from '@/app/modules/auth/core/service';
import { MatIconModule } from '@angular/material/icon';
import { LoaderService } from '@/app/common/services/loader/loader.service';
import { NzSkeletonModule } from 'ng-zorro-antd/skeleton';
import { User } from '@/app/modules/user/core/type';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { AvatarComponent } from '@/app/common/components/avatar/avatar.component';

@Component({
  selector: 'az-blc-sidenav',
  templateUrl: './sidenav.component.html',
  styleUrls: ['./sidenav.component.scss'],
  standalone: true,
  imports: [
    NzMenuModule,
    NzIconModule,
    NzGridModule,
    NzLayoutModule,
    NzSkeletonModule,
    NzButtonModule,
    MatIconModule,
    RouterModule,
    AvatarComponent,
    NgIf,
    AsyncPipe,
    NgForOf,
    NgComponentOutlet,
    NgTemplateOutlet,
  ],
})
export class SidenavComponent implements OnInit, OnDestroy {
  @Input() collapsed: boolean = false;

  @Input() version?: string;

  @Output() onColapse = new EventEmitter();

  private subscription: Subscription = new Subscription();

  isLoading$ = new BehaviorSubject<boolean>(false);

  user?: User;

  menu: ItemMenu[] = [];

  constructor(
    private router: Router,
    private menuService: SidenavService,
    private loaderService: LoaderService,
    public authService: AuthService
  ) {}

  ngOnInit(): void {
    this.listenMenu();
    this.loadData();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  /**
   * @description Navigate to any router
   * - Can't check if user has permition
   * @param path
   * @param args any option to send with router
   */
  navigateTo(path: string, args?: object) {
    this.router.navigateByUrl(path, { ...args });
  }

  logout() {
    this.loaderService.executeWithLoader(this.authService.logout()).subscribe({
      next: () => {
        this.router.navigateByUrl('/login');
      },
    });
  }

  private listenMenu() {
    this.subscription.add(
      this.menuService.menu$.subscribe((menu) => {
        this.menu = menu;
      })
    );
  }

  private loadData() {
    this.loaderService
      .executeWithLoader(combineLatest([this.loadUser()]), this.isLoading$)
      .subscribe({
        next: ([user]) => {
          this.user = user;
          this.menuService.loadMenu();
        },
        error: () => {
          delete this.user;
          this.authService.logout().subscribe();
        },
      });
  }

  private loadUser() {
    return this.authService.authenticatedUser.pipe(take(1));
  }
}
